import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingCartoonGeneratorConfig } from '@/data/landingConfig/landingCartoonGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_CartoonGenerator } from './schemaObject';

interface Props {}
const CartoonGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_CartoonGenerator} />

			<LandingTemplate
				data={landingCartoonGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCartoonGenerator()}
			/>
		</>
	);
};

export default CartoonGenerator;
